<template>
  <div class="row">
    <div class="col-12 my-2">
      <div class="col-12 col-sm-4 card-header-select-box px-sm-2">
        <div class="legend">
          <i class="fa fa-circle text-danger"></i>
          Олдинги ҳолатдан +- 30% фарқ қилса
        </div>
      </div>
      <div class="col-12 col-sm-4 card-header-select-box px-sm-2">
        <div class="legend">
          <i class="fa fa-circle text-warning"></i>
          Мин билан максимум оралиғи 70 % фарқ қилса
        </div>
      </div>
    </div>
    <div class="col-12 my-2">
      <div class="card-header-actions">
        <div class="col-lg-8 col-md-8 col-12 card-header-filter-box">
          <div class="row align-items-end">
            <div class="col-12 col-sm-4 card-header-select-box pr-sm-2">
              <div class="form-group">
                <label>{{$t("realEstate.field.province")}}:</label>
                <v-select
                    label="name"
                    v-model="province"
                    :filterable="false"
                    :options="provinces"
                    @search="onProvinceSearch"
                    @search:focus="onProvinceFocus"
                >
                  <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                </v-select>
              </div>
            </div>
            <div class="col-12 col-sm-4 card-header-select-box px-sm-2">
              <div class="form-group">
                <label>{{$t("realEstate.field.region")}}:</label>
                <v-select
                    label="name"
                    v-model="region"
                    :filterable="false"
                    :options="regions"
                    @search="onRegionSearch"
                    @search:focus="onRegionFocus"
                >
                  <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                </v-select>
              </div>
            </div>
            <div class="col-12 col-sm-4 card-header-select-box px-sm-2">
              <div class="form-group">
                <label>{{$t("newRealEstate.field.plus.mfy")}} <span class="red">*</span></label>
                <v-select v-model="mfy" label="name"
                          :options="mfyList"
                          :filterable="false"
                          @search="mfySearch"
                          @search:focus="mfyFocus"
                >
                  <template slot="option" slot-scope="option" v-if="option && option.name">
                    <div v-html="option.name"></div>
                  </template>
                  <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                </v-select>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-12 justify-content-md-end mt-md-0 mt-2 card-header-btns-box">
          <button class="all-btn add-btn m-0"
                  v-if="hasPermission('SETTINGS_BUILDING_ANALOG_SETTING_ADD')"
                  :disabled="loading"
                  @click="onShowUpdateModal(null)">
            {{$t("action.refresh")}}
          </button>
          <button class="all-btn edit-btn m-0 ml-3"
                  v-if="hasPermission('SETTINGS_BUILDING_ANALOG_SETTING_ADD')"
                  @click="onSaveByProvince">
            <i class="fa fa-save"></i>
            <span>Умумий сақлаш</span>
          </button>
          <button class="all-btn m-0 ml-3" @click="onSearch">
            <i class="fa fa-search"></i>
            <span>{{$t('main.search')}}</span>
          </button>
        </div>
      </div>
    </div>
    <div class="col-12 mt-3">
      <div class="table-wrapper">
        <table class="customers">
          <thead>
            <tr>
              <th rowspan="2">#</th>
              <th rowspan="2">Вилоят</th>
              <th rowspan="2">Туман</th>
              <th rowspan="2">МФЙ</th>
              <th :colspan="5" v-for="(section, index) in buildingSections" :key="`section`+ index">{{section.label}}</th>
            </tr>
            <tr>
              <template v-for="(section, index) in buildingSections">
                <th :key="`до-${section.code}`+ index">До</th>
                <th :key="`после-${section.code}`+ index">После</th>
                <th :key="`create-date-${section.code}`+ index">{{$t("realEstate.field.createdDate")}}</th>
                <th :key="`created-by-${section.code}`+ index">Маъсул шахс</th>
                <th :key="`action-${section}`+ index"></th>
              </template>
            </tr>
            </thead>
            <tbody v-if="!loading && results && results.data">
            <tr v-for="result in results.data" :key="result.id">
              <td class="text-center">
                <div>
                  <span class="badge badge-success" v-if="result.action === 'ACTIVE'">Актив</span>
                  <span class="badge badge-secondary" v-else-if="result.action === 'DRAFT'">Актив эмас</span>
                  <span class="badge badge-danger" v-else-if="result.action === 'DELETED'">Ўчирилган</span>
                  <span class="badge badge-warning" v-else-if="result.action === 'ANALOGS_NOT_FOUND'">Аналог топилмади</span>
                  <span class="badge badge-warning" v-else-if="result.action === 'OLD_SETTING_NOT_FOUND'">Аввалги мин максимум топилмади</span>
                </div>
                <div class="form-check pl-0 checkbox-inline">
                  <label class="form-check-label"
                         style="padding-left:22px !important">
                    <input class="form-check-input" type="checkbox"
                           v-model="result.select"
                    >
                    <span class="form-check-sign"></span>
                    {{result.id}}
                  </label>
                </div>
              </td>
              <td>{{result.province.name}}</td>
              <td>{{result.region.name}}</td>
              <td>{{result.mfy.name}}</td>
              <template v-for="(section,index) in buildingSections">
                <template v-for="item in result.items">
                  <template v-if="section.code === item.category">
                    <td :key="`old-min-${index}-${section.code}` + item.id">
                      {{item.oldMin | currency('', 0, { thousandsSeparator: ' ' })}}-<br> {{item.oldMax | currency('', 0, { thousandsSeparator: ' ' })}}
                      <div class="legend">
                        <i v-if="item.previousStatus === 'RED'" class="fa fa-circle text-danger"></i>
                      </div>
                    </td>
                    <td :key="`new-max-${index}-${section.code}` + item.id">
                      {{item.min | currency('', 0, { thousandsSeparator: ' ' })}}-<br> {{item.max | currency('', 0, { thousandsSeparator: ' ' })}}
                      <div class="legend">
                        <i v-if="item.currentStatus === 'YELLOW'" class="fa fa-circle text-warning"></i>
                      </div>
                    </td>
                    <td :key="`created-date-${index}-${section.code}` + item.id">
                      {{new Date(item.createdDate) | dateFormat('DD.MM.YYYY HH:mm:ss')}}
                      <br>
                      <span class="text-secondary">#:{{item.id}}</span>
                      <br>
                      <span class="text-secondary" v-if="item.exchangeRateUsd">Курс: </span>
                      <br>
                      <span class="text-dark" v-if="item.exchangeRateUsd">{{item.exchangeRateUsd | currency('', 2, { thousandsSeparator: ' ' })}}</span>
                      <a href="#" @click="onShowAnalogItemAnalogs(item)" v-if="item.action === 'AUTOMATICALLY'">
                        Аналоглар
                      </a>
                    </td>
                    <td :key="`created-by-${index}-${section.code}` + item.id">{{item.createdBy.name}}</td>
                    <td :key="`action-${index}-${section.code}`+ item.id">
                      <div>
                        <button class="all-btn btn-sm edit-btn" @click="onRefreshByItem(item)" v-if="hasPermission('SETTINGS_BUILDING_ANALOG_SETTING_ADD')">
                          {{$t("action.refresh")}}
                        </button>
                        <button class="all-btn btn-sm add-btn mt-2" @click="onSaveByItem(item)" v-if="hasPermission('SETTINGS_BUILDING_ANALOG_SETTING_ADD')">
                          {{$t("action.save")}}
                        </button>
                        <button class="all-btn btn-sm view-btn mt-2" @click="onSaveManuallyByItem(item)" v-if="hasPermission('SETTINGS_BUILDING_ANALOG_SETTING_ADD')">
                          {{$t("action.addManually")}}
                        </button>
                      </div>
                    </td>
                  </template>
                </template>
                <template v-if="!result.categories || !result.categories.includes(section.code)">
                  <td :key="`not-exist-old-min-${index}-${section.code}`"></td>
                  <td :key="`not-exist-new-max-${index}-${section.code}`"></td>
                  <td :key="`not-exist-created-date-${index}-${section.code}`"></td>
                  <td :key="`not-exist-created-by-${index}-${section.code}`"></td>
                  <td :key="`not-exist-action-${index}-${section.code}`">
                    <div>
                      <button class="all-btn btn-sm edit-btn" @click="onRefreshByNotExistingItem(result, section.code)">
                        {{$t("action.refresh")}}
                      </button>
                    </div>
                  </td>
                </template>
              </template>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="text-center">
        <div class="loader mt-5 mb-5" v-if="loading"></div>
        <span class="no-data mt-5 mb-5" v-if="!loading && results && results.data && results.data.length===0">{{$t("messages.list.empty")}}</span>
      </div>
      <div class="row" v-if="!loading && results && results.total && results.total > 1 ">
        <div class="col-12 pt-3 pb-3">
          <b-pagination :total-rows="results.total" v-model="filter.page.page" :per-page="filter.page.size" @change="onPageChange">
          </b-pagination>
        </div>
      </div>
    </div>
    <AnalogSettingCalculateUpdateModal @change="initList"></AnalogSettingCalculateUpdateModal>
    <AnalogSettingItemAnalogsModal @change="initList"></AnalogSettingItemAnalogsModal>
    <AnalogSettingItemAddModal @change="initList"></AnalogSettingItemAddModal>
    <AnalogSettingUpdateActionByProvinceModal @change="initList"></AnalogSettingUpdateActionByProvinceModal>
  </div>
</template>
<script>

import initFilterModel from '@/shared/filter';
import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
import AnalogSettingCalculateUpdateModal from '@/views/config/real-estate/analog-setting/AnalogSettingCalculateUpdateModal.vue'
import AnalogSettingItemAnalogsModal from '@/views/config/real-estate/analog-setting/AnalogSettingItemAnalogsModal.vue'
import AnalogSettingItemAddModal from '@/views/config/real-estate/analog-setting/AnalogSettingItemAddModal.vue'
import AnalogSettingUpdateActionByProvinceModal from '@/views/config/real-estate/analog-setting/AnalogSettingUpdateActionByProvinceModal.vue'

export default {
  name: "AnalogSettingCalculateList",
  components: {
    'b-pagination': bPagination,
    AnalogSettingCalculateUpdateModal,
    AnalogSettingItemAnalogsModal,
    AnalogSettingItemAddModal,
    AnalogSettingUpdateActionByProvinceModal
  },
  data() {
    return {
      processing: false,
      loading: false,
      filter: initFilterModel(),
      filterProvince: initFilterModel(),
      filterRegion: initFilterModel(),
      filterMfy: initFilterModel(),
      results: null,
      province: null,
      region: null,
      mfy: null,
      mfyList: [],
      provinces: [],
      regions: [],
      buildingSections: [
        {
          code: 'ResidentialIndividual',
          label: 'Турар'
        },
        {
          code: 'ResidentialMultiStorey',
          label: 'Кўп қаватли'
        },
        {
          code: 'NotResidential',
          label: 'Нотурар'
        }
      ]
    }
  },
  methods: {
    initList() {
      this.loading = true;
      const vm = this;
      this.$http.post('/analog-setting/list', this.filter)
          .then(res => {
            this.results = res.data;
            if (this.results && this.results.data) {
              this.results.data.forEach((field) => {
                field.select = (field.action === 'ACTIVE');
              });
            }

            vm.loading = false;
          }, err => {
            console.log(err);
            vm.loading = false;
          });
    },
    onRefreshByItem(analogSettingItem) {
      this.$swal({
        title: 'Янгилашни амалга оширасизми?',
        text: 'Янгилаш учун "Тасдиқлаш" кнопкасини босинг',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#78b414',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Тасдиқлаш',
        cancelButtonText: 'Бекор қилиш'
      }).then((result) => {
        if (result.value) {
          this.processing = true;
          this.$http.post('/analog-setting/update-by-item', {id: analogSettingItem.id, category:  analogSettingItem.category, analogSettingId: analogSettingItem.analogSettingId})
              .then(res => {
                let resData = res.data;
                console.log(resData)
                this.initList()
                this.processing = false;

              }).catch(({response}) => {
            console.log('error')
            console.log(response)

            this.$swal({
              type: 'error',
              title: '',
              text: response.data.message ? response.data.message : response.data
            });

            this.processing = false;
          })
        }
      })
    },
    onRefreshByNotExistingItem(analogSetting, category) {
      this.processing = true;
      this.$http.post('/analog-setting/update-not-existing-item', {category:  category, analogSettingId: analogSetting.id})
          .then(res => {
            let resData = res.data;
            console.log(resData)
            this.initList()
            this.processing = false;

          }).catch(({response}) => {
        console.log('error')
        console.log(response)

        this.$swal({
          type: 'error',
          title: '',
          text: response.data.message ? response.data.message : response.data
        });

        this.processing = false;
      })
    },
    onSaveByItem(analogSettingItem) {

      const existingActiveAnalogSettingIds = []
      this.results.data.forEach((analog) => {
        if (analog.select && analogSettingItem.analogSettingId === analog.id) {
          existingActiveAnalogSettingIds.push(analog.id)
        }
      })

      if (existingActiveAnalogSettingIds.length > 0) {
        this.processing = true;
        this.$http.post('/analog-setting/update-action', {ids:  existingActiveAnalogSettingIds, action: 'ACTIVE'})
            .then(res => {
              let resData = res.data;
              console.log(resData)
              this.initList()
              this.processing = false;

            }).catch(({response}) => {
          console.log('error')
          console.log(response)

          this.$swal({
            type: 'error',
            title: '',
            text: response.data.message ? response.data.message : response.data
          });

          this.processing = false;
        })
      }
    },
    onSaveByProvince() {
      this.$eventBus.$emit("showAnalogSettingUpdateActionByProvinceModal")
    },
    onSaveManuallyByItem(analogSettingItem) {
      this.$eventBus.$emit("showAnalogSettingItemAddModal", analogSettingItem)
    },
    onShowUpdateModal(data) {
      this.$eventBus.$emit("showAnalogSettingCalculateUpdateModal", data)
    },
    onShowAnalogItemAnalogs(item) {
      this.$eventBus.$emit("showAnalogSettingItemAnalogsModal", item)
    },
    onPageChange(page) {
      this.filter.page.page = page;
      this.initList();
    },
    onProvinceFocus() {
      this.provinces = [];
      this.filterProvince.search = '';
      this.$http.post('/province/list', this.filterProvince)
          .then(res => {
            this.provinces = res.data.data;
          }, err => {
            console.log(err);
          });
    },
    onProvinceSearch(searchTxt, loading) {
      loading(true);
      this.provinces = [];
      this.filterProvince.search = searchTxt;
      this.$http.post('/province/list', this.filterProvince)
          .then(res => {
            this.provinces = res.data.data;
            loading(false);
          }, err => {
            console.log(err);
          });
    },
    onRegionSearch(searchTxt, loading) {
      loading(true);
      this.regions = [];
      this.filterRegion.search = searchTxt;
      this.filterRegion.provinceId = (this.province && this.province.id) ? this.province.id : 0;
      this.$http.post('/region/search', this.filterRegion)
          .then(res => {
            this.regions = res.data.data;
            loading(false);
          }, err => {
            console.log(err);
          });
    },
    onRegionFocus() {
      this.regions = [];
      this.filterRegion.provinceId = (this.province && this.province.id) ? this.province.id : 0;
      this.$http.post('/region/search', this.filterRegion)
          .then(res => {
            this.regions = res.data.data;
          }, err => {
            console.log(err);
          });
    },
    mfyFocus() {
      this.mfyList = [];
      if (!this.mfy) {
        this.filterMfy.search = '';
      }

      this.filterMfy.code = (this.region && this.region.code) ? this.region.code : "";
      this.$http.post('/mfy/search', this.filterMfy)
          .then(res => {
            this.mfyList = res.data.data;
          }, err => {
            console.log(err);
          });
    },
    mfySearch(searchTxt, loading) {
      loading(true);
      this.mfyList = [];
      this.filterMfy.search = searchTxt;
      this.filterMfy.code = (this.region && this.region.code) ? this.region.code : "";
      this.$http.post('/mfy/search', this.filterMfy)
          .then(res => {
            this.mfyList = res.data.data;
            loading(false);
          }, err => {
            console.log(err);
          });
    },
    onSearch() {
      this.filter.province = this.province;
      this.filter.region = this.region;
      this.filter.microRegion = this.microRegion;
      this.filter.mfy = this.mfy
      this.initList();
    }
  },
  created() {
    this.filterProvince.page.size = 1000;
    this.filterRegion.page.size = 1000;
    this.initList();
  }
}
</script>

<style scoped>

  .customers th {
    min-width: 75px !important;
    padding: 2px !important;
    background-color: #77BEF0 !important;
    color: #213448 !important;
  }

  .customers td {
    min-width: 85px;
  }

</style>